import _ from "lodash";
import { Formik } from "formik";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell
} from "@material-ui/core";
import Select from "react-select";
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";
import numberFormatter from "../../utils/numberFormatter";
import { getDealToSell, sellDeal, recalculateDealExitDebtYield } from "./changeDealStatusModal.store";
import { DatePicker, MoneyInput, PercentInput, TextAreaInput, TextInput, DecimalInput} from "../../components/Global/FastFormikMaterial";
import { getSalesBrokers } from "../../store/state/enumeratedTypes";
import { getContactsByCompany } from "../../store/state/contacts";
import { setEnumeratedTypesListState } from "../../components/Global/Fields/util";

const StyledTableCell = styled(TableCell)`
  padding-left: 10px !important;
  padding-right: 10px !important;
`;

const HeaderCell = styled(StyledTableCell)`
  font-weight: 700 !important;
  color: black !important;
`;

const StyledMoneyInput = styled(MoneyInput)`
  width: 125px;
  input {
    text-align: right !important;
  }
`;

const StyledDecimalInput = styled(DecimalInput)`
  width: 125px;
  input {
    text-align: right !important;
  }
`;

const StyledPercentInput = styled(PercentInput)`
  width: 125px;
  input {
    text-align: right !important;
  }
`;

const HeightLimitedTableContainer = styled.div`
  max-height: 800px;
  overflow-y: auto;
  padding-left: 10px;
  padding-right: 10px;
`;

const StyledDatePicker = styled(DatePicker)`
  input {
    width: 95px;
  }
`;

const StyledSelect = styled(Select)`
  width: 250px;
  div {
    border: none;
    color: rgba(0, 0, 0, 0.537254901960784);
  }
`;

const StepInstructions = styled.div`
  margin-left: 20px;
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 0.537254901960784);
`;

const SectionLabel = styled.div`
  color: rgba(0, 0, 0, 0.537254901960784);
  font-weight: bold;
  text-transform: uppercase;
`;

const CompanyNameTextInput = styled(TextInput)`
  input {
    width: 300px;
  }
`;

const ErrorMessage = styled(Grid)`
  color: red;
  width: 100%;
  padding-left: 20px;
  display: ${props => (props.display ? undefined : "none")};
`;

class PartialReleaseWizardModal extends Component {
  constructor(props) {
    super(props);

    this.state = {clearedPropertyData: false, initiatedHedgesToUnwind: false, hasErrors: false, activeStep: 0, salesBrokerCompanies: [] };
  }

  componentDidMount() {
    this.props.getDealToSell(this.props.dealId);
    this.props.getSalesBrokers();
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.enumeratedTypes && this.props.enumeratedTypes.sales_brokers && this.props.enumeratedTypes.sales_brokers.length > 0 && this.state.salesBrokerCompanies.length === 0) {
      setEnumeratedTypesListState("sales_brokers", "salesBrokerCompanies", this);
    }
    if(this.props.deal && !this.state.initiatedHedgesToUnwind){
      this.props.deal.hedges.forEach(hedge => hedge.unwind=true);
      this.setState({initiatedHedgesToUnwind:true});
    }
    if(prevProps && prevProps.dealId !== this.props.dealId )
      this.props.getDealToSell(this.props.dealId)
  };



  getStepCount = () => (this.props.deal.hedges.length > 0 ? 4 : 3);

  isActiveStepPayOffLoans = () => this.state.activeStep === 1;

  isActiveStepUnwindHedges = () => this.state.activeStep === 2 && this.getStepCount() === 4;

  isActiveStepDispositionProperties = () => this.state.activeStep === 0;

  isActiveStepMemorializeData = () => (this.state.activeStep === 2 && this.getStepCount() === 3) || (this.state.activeStep === 3 && this.getStepCount() === 4);

  validate = deal => {
    let valid = true;
    this.setState({plainTextError: null})
    const errors = {};
    if (this.isActiveStepPayOffLoans()) {
      errors.loans = [];
      for (let loanIndex = 0; loanIndex < deal.loans.length; loanIndex++) {
        const loan = deal.loans[loanIndex];
        errors.loans.push({});
        if (!loan.balanceAtPayoff) {
          errors.loans[loanIndex].balanceAtPayoff = "Required";
          valid = false;
        }
        if (!loan.actualPrepaymentPenalty) {
          errors.loans[loanIndex].actualPrepaymentPenalty = "Required";
          valid = false;
        }
        if (!loan.paidOffDate) {
          errors.loans[loanIndex].paidOffDate = "Required";
          valid = false;
        }
      }
    }

    if (this.isActiveStepUnwindHedges()) {
      errors.hedges = [];
      for (let hedgeIndex = 0; hedgeIndex < deal.hedges.length; hedgeIndex++) {
        const hedge = deal.hedges[hedgeIndex];
        errors.hedges.push({});
        if (hedge.unwind) {
          if (!hedge.notionalAtTermination) {
            errors.hedges[hedgeIndex].notionalAtTermination = "Required";
            valid = false;
          }
          if (!hedge.terminationValue) {
            errors.hedges[hedgeIndex].terminationValue = "Required";
            valid = false;
          }
          if (!hedge.earlyTerminationDate) {
            errors.hedges[hedgeIndex].earlyTerminationDate = "Required";
            valid = false;
          }
        }
      }
    }

    if (this.isActiveStepDispositionProperties()) {
      errors.properties = [];
      let allPropertiesMarked = true;
      for (let propertyIndex = 0; propertyIndex < deal.properties.length; propertyIndex++) {
        const property = deal.properties[propertyIndex];
        errors.properties.push({});
        if(property.shouldDisposition){
          if (!property.salesPrice) {
            errors.properties[propertyIndex].salesPrice = "Required";
            valid = false;
          }
          if (!property.pricePerSquareFoot) {
            errors.properties[propertyIndex].pricePerSquareFoot = "Required";
            valid = false;
          }
          if (!property.actualExitDate) {
            errors.properties[propertyIndex].actualExitDate = "Required";
            valid = false;
          }
          if (!property.exitCapRate) {
            errors.properties[propertyIndex].exitCapRate = "Required";
            valid = false;
          }
        } else {
          allPropertiesMarked = false;
        }
      }
      if(allPropertiesMarked){
        errors.plainTextError = "Cannot mark all properties";
        valid = false;
      }
    }

    return valid ? {} : errors;
  };

  markAsSold = deal => {
    deal.internalRateOfReturn = deal.internalRateOfReturn ? parseFloat(deal.internalRateOfReturn) / 100 : null;
    deal.cashOnCash = deal.cashOnCash ? parseFloat(deal.cashOnCash) / 100 : null;
    this.props.sellDeal({isPartialRelease: true, ...deal});
    this.props.onClose();
  };

  clearProperties = (formik) => {
    if(this.props.deal && !this.state.clearedPropertyData){
      this.props.deal.properties.forEach(x => {
        x.salesPrice = null;
        x.pricePerSquareFoot = null;
        x.pricePerUnit = null;
        x.exitCapRate = null;
      });
      this.setState({clearedPropertyData: true});
    }
  } 

  renderPayOffLoans = () => {
    return (
      <>
        <StepInstructions>Please enter the pay off information for the following active loans:</StepInstructions>
        <HeightLimitedTableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <HeaderCell />
                <HeaderCell align="right">Principle Paydown</HeaderCell>
                <HeaderCell align="right">Prepayment Penalty</HeaderCell>
                <HeaderCell align="right">Paid Off Date</HeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.deal.loans.map((loan, loanIndex) => (
                <TableRow key={loan.id}>
                  <HeaderCell component="th">
                    {_.get(loan, "loanCompanyBridge[0].company.name") || "N/A"} {" | "}
                    {loan.loanTermMonths ? `${(loan.loanTermMonths / 12).toFixed(2)} Years` : "N/A"} {" | "}
                    {loan.rateTypeRef && loan.rateTypeRef.name ? loan.rateTypeRef.name : "N/A"} {" | "} {numberFormatter.maskCurrency(loan.amount) || "N/A"}
                  </HeaderCell>
                  <StyledTableCell>
                    <StyledMoneyInput fieldName={`loans[${loanIndex}].balanceAtPayoff`} />
                  </StyledTableCell>
                  <StyledTableCell>
                    <StyledMoneyInput fieldName={`loans[${loanIndex}].actualPrepaymentPenalty`} />
                  </StyledTableCell>
                  <StyledTableCell>
                    <StyledDatePicker fieldName={`loans[${loanIndex}].paidOffDate`} errorOnBottom />
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </HeightLimitedTableContainer>
        <StepInstructions style={{ marginTop: 30 }}>
          NOTE: If the information above is not available at this time, you will need to enter this data on each individual loan at a later date.
        </StepInstructions>
      </>
    );
  };

  renderUnwindHedges = (formik) => {
    return (
      <>
        <StepInstructions>Please fill out the following information to unwind active hedges:</StepInstructions>
        <HeightLimitedTableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <HeaderCell>Partial Unwind?</HeaderCell>
                <HeaderCell align="right">Unwound Notional</HeaderCell>
                <HeaderCell align="right">Termination Value</HeaderCell>
                <HeaderCell align="right">Termination Date</HeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formik.values.hedges.map((hedge, hedgeIndex) => (
                <TableRow key={hedge.id}>
                  <HeaderCell component="th">
                    <Checkbox
                      checked={hedge.unwind}
                      onChange={() => {
                        hedge.unwind = !hedge.unwind;
                        this.forceUpdate();
                      }}
                    />
                    {hedge.hedgeProvider.name} -{hedge.hedgeType.value}
                  </HeaderCell>
                  <StyledTableCell>
                    <div style={{ width: 125 }}>{hedge.unwind && <StyledMoneyInput fieldName={`hedges[${hedgeIndex}].notionalAtTermination`} />}</div>
                  </StyledTableCell>
                  <StyledTableCell>
                    <div style={{ width: 125 }}>{hedge.unwind && <StyledMoneyInput fieldName={`hedges[${hedgeIndex}].terminationValue`} />}</div>
                  </StyledTableCell>
                  <StyledTableCell>
                    <div style={{ width: 155 }}>
                      {hedge.unwind && <StyledDatePicker fieldName={`hedges[${hedgeIndex}].earlyTerminationDate`} errorOnBottom />}
                    </div>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </HeightLimitedTableContainer>
      </>
    );
  };

  renderPropertyRows = (properties, formik) => {
    const out = [];
    for(let i = 0; i < properties.length; i++){
      let propertyIndex = i;
      let property = properties[i];
      out.push(
        <TableRow key={property.id}>
          <HeaderCell component="th">
          <Checkbox
            checked={!!property.shouldDisposition}
            onChange={() => {
              formik.setFieldValue(`properties[${i}].shouldDisposition`, !property.shouldDisposition);
              formik.setFieldValue(`properties[${i}].actualExitDate`, null);
            }}
          />
            {property.address}
            </HeaderCell>
          {property.shouldDisposition &&  
            <>
              <StyledTableCell>
                <StyledMoneyInput onBlur={()=>this.calculateCapRate(propertyIndex, formik)} fieldName={`properties[${propertyIndex}].salesPrice`} />
              </StyledTableCell>
              <StyledTableCell>
                <StyledMoneyInput fieldName={`properties[${propertyIndex}].pricePerUnit`} />
              </StyledTableCell>
              <StyledTableCell>
                <StyledMoneyInput fieldName={`properties[${propertyIndex}].pricePerSquareFoot`} />
              </StyledTableCell>
              <StyledTableCell>
                <StyledPercentInput fieldName={`properties[${propertyIndex}].exitCapRate`} />
              </StyledTableCell>
              <StyledTableCell>
                <StyledDatePicker fieldName={`properties[${propertyIndex}].actualExitDate`} errorOnBottom />
              </StyledTableCell>
            </>
          }
        </TableRow>
      );
    }
    return out;
  }

  renderDispositionProperties = (formik) => {
    this.clearProperties(formik);
    return (
      <>
        <StepInstructions>Please fill out the following information to disposition properties:</StepInstructions>
        <HeightLimitedTableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <HeaderCell />
                <HeaderCell align="right">Sales Price</HeaderCell>
                <HeaderCell align="right">Price Per Unit</HeaderCell>
                <HeaderCell align="right">Price Per Sq. Ft.</HeaderCell>
                <HeaderCell align="right">Cap Rate</HeaderCell>
                <HeaderCell align="right">Sale Date</HeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.renderPropertyRows(formik.values.properties, formik)}
            </TableBody>
          </Table>
        </HeightLimitedTableContainer>
      </>
    );
  };

  calculateCapRate = (propertyIndex, formik) => {
    let salesPrice = formik.values.properties[propertyIndex].salesPrice;
    let noiActual = this.props.deal.properties[propertyIndex].noiActual;
    let capRate = salesPrice && noiActual ? (noiActual / salesPrice) * 100 : null;
    if(!capRate) return null;
    formik.setFieldValue(`properties[${propertyIndex}].exitCapRate`, capRate.toFixed(2));
  }

  hasSalesBrokerContacts = (selectedSalesBrokerContactId, salesBrokerContacts) =>
    selectedSalesBrokerContactId &&
    salesBrokerContacts &&
    salesBrokerContacts[selectedSalesBrokerContactId] &&
    salesBrokerContacts[selectedSalesBrokerContactId].length > 0;

  renderMemorializeData = formik => {
    const { salesBrokerContacts } = this.props;
    let contacts;
    if (this.hasSalesBrokerContacts(formik.values.salesBrokerCompanyId, salesBrokerContacts)) {
      contacts = salesBrokerContacts[formik.values.salesBrokerCompanyId].map(x => ({
        label: `${x.firstName ? x.firstName : ""} ${x.lastName ? x.lastName : ""}`,
        value: x.id
      }));
    } else {
      contacts = [];
    }

    return (
      <>
        <StepInstructions>Please fill out the following information:</StepInstructions>
        <Grid container spacing={40} direction="column" style={{ paddingLeft: 25, paddingRight: 10 }}>
          <Grid container item direction="column" spacing={0}>
            <Grid item>
              <SectionLabel>Exit Metrics</SectionLabel>
            </Grid>
              <div>
              <div style={{display:"inline-block", marginRight: "30px"}}>
                <StyledPercentInput fieldName="internalRateOfReturn" decimalScale={3} label="IRR" autoFocus />
              </div>
              <div style={{display:"inline-block", marginRight: "30px"}}>
                <StyledPercentInput fieldName="cashOnCash" decimalScale={3} label="Cash on Cash" />
              </div>
              <div style={{display:"inline-block", marginRight: "30px"}}>
                <StyledDecimalInput fieldName="equityMultiple" decimalScale={3} label="Equity Multiple" />
              </div>
              <div style={{display:"inline-block", marginRight: "30px"}}>
                <StyledPercentInput fieldName="exitDebtYield" decimalScale={3} label="Debt Yield" />
              </div>
            </div>
            
          </Grid>
          <Grid container item direction="column" spacing={0}>
            <Grid item>
              <SectionLabel>Sales Broker</SectionLabel>
            </Grid>
            <Grid item container direction="row" spacing={16}>
              <Grid item>
                <StyledSelect
                  placeholder="Sales Broker Company"
                  options={this.state.salesBrokerCompanies}
                  onChange={option => {
                    formik.setFieldValue("salesBrokerCompanyId", option.value);
                    formik.setFieldValue("salesBrokerContactId", null);
                    this.props.getContactsByCompany({ companyId: option.value });
                    this.forceUpdate();
                  }}
                />
              </Grid>
              <Grid item>
                <StyledSelect placeholder="Sales Broker" options={contacts} onChange={option => formik.setFieldValue("salesBrokerContactId", option)} />
              </Grid>
              <div style={{display:"inline-block", marginLeft: "20px"}}>
                <StyledMoneyInput fieldName="brokerFees" label="Broker Fees" />
              </div>
            </Grid>
          </Grid>
          <Grid container item direction="column" spacing={0}>
            <Grid item>
              <SectionLabel>Buyer</SectionLabel>
            </Grid>
            <Grid item container direction="row" spacing={16}>
              <Grid item>
                <CompanyNameTextInput fieldName="buyerCompany" label="Buyer Company" />
              </Grid>
              <Grid item>
                <CompanyNameTextInput fieldName="buyer" label="Buyer" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <TextAreaInput fullWidth fieldName="notesOnBuyer" label="Notes on Buyer" />
          </Grid>
        </Grid>
      </>
    );
  };

  renderDialog = formik => {
    return (
      <Dialog open maxWidth="lg">
        <DialogTitle>Partial Release</DialogTitle>
        <DialogContent style={{ height: 650, minWidth: 1100 }}>
          <Stepper activeStep={this.state.activeStep} alternativeLabel>
            <Step key="dispositionProperties">
              <StepLabel>Disposition Properties</StepLabel>
            </Step>
            <Step key="payOffLoans">
              <StepLabel>Pay Off Loans</StepLabel>
            </Step>
            {this.getStepCount() === 4 && (
              <Step key="unwindHedges">
                <StepLabel>Unwind Hedges</StepLabel>
              </Step>
            )}
           <Step key="memorializeData">
              <StepLabel>Memorialize Data</StepLabel>
            </Step>
          </Stepper>

          {this.isActiveStepPayOffLoans() && this.renderPayOffLoans(formik)}

          {this.isActiveStepUnwindHedges() && this.renderUnwindHedges(formik)}

          {this.isActiveStepDispositionProperties() && this.renderDispositionProperties(formik)}

          {this.isActiveStepMemorializeData() && this.renderMemorializeData(formik)}
        </DialogContent>
        <DialogActions>
          {this.state.hasErrors && this.state.plainTextError && 
          <ErrorMessage display={this.state.hasErrors}>Cannot select all properties for release</ErrorMessage>
          }
          <ErrorMessage display={this.state.hasErrors}>Please correct errors before continuing.</ErrorMessage>
          <SecondaryButton
            style={{ marginLeft: '16px' }}
            label="Cancel"
            onClick={this.props.onClose}
            size={ButtonSizeOptions.smFluid}
            />
          {!this.isActiveStepDispositionProperties() && (
            <SecondaryButton
            style={{ marginLeft: '16px' }}
            label="Back"
            onClick={() => this.setState(prevState => ({ hasErrors: false, activeStep: prevState.activeStep - 1 }))}
            size={ButtonSizeOptions.smFluid}
            />
          )}
          {!this.isActiveStepMemorializeData() && (
            <PrimaryButton
            style={{ marginLeft: '16px' }}
              label="Next"
              onClick={() => {
                formik.validateForm().then(errors => {
                  if (_.isEmpty(errors)) {
                    this.setState(prevState => ({plainTextError: null, hasErrors: false, activeStep: prevState.activeStep + 1 }));
                  } else {
                    this.setState({ hasErrors: true, plainTextError: errors.plainTextError });
                  }
                });
              }}
              size={ButtonSizeOptions.smFluid}
              />)}
          {this.isActiveStepMemorializeData() && 
          <PrimaryButton 
            label="Confirm Partial Release"
            size={ButtonSizeOptions.smFluid}
            style={{ marginLeft: '16px' }}
            onClick={x=>{
              this.props.recalculateDealExitDebtYield({dealId: this.props.deal.id});
              formik.handleSubmit(x);
              }}
          />}
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    if (!this.props.deal) {
      return null;
    }
    return (
      <Formik
        initialValues={this.props.deal}
        onSubmit={this.markAsSold}
        validate={this.validate}
        render={this.renderDialog}
        validateOnChange={this.state.hasErrors}
      />
    );
  }
}

PartialReleaseWizardModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

function mapStateToProps({ changeDealStatusModal, enumeratedTypes, contacts }) {
  return {
    deal: changeDealStatusModal.dealToSell,
    enumeratedTypes: enumeratedTypes.enumeratedTypes,
    salesBrokerContacts: contacts.contactsByCompany
  };
}

export default compose(connect(mapStateToProps,
                              { 
                              getDealToSell,
                              sellDeal,
                              getSalesBrokers,
                              getContactsByCompany,
                              recalculateDealExitDebtYield
                            }))(PartialReleaseWizardModal);
